import type { CepResponseProps } from 'src/components/checkout/steps/shipping/types'
import { axiosClient } from 'src/services/axiosInstance'

export async function fetchCepData(
  cep: string
): Promise<CepResponseProps | null> {
  try {
    const encodedCep = encodeURIComponent(cep)

    const { data }: { data: CepResponseProps } = await axiosClient.get(
      `/api/getAddressByPostalCode?cep=${encodedCep}`
    )

    return data
  } catch {
    return null
  }
}
